var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('v-chip',{staticClass:"ma-2",attrs:{"color":"green","outlined":"","label":""}},[_vm._v(" Yes ")]):_c('v-chip',{staticClass:"ma-2",attrs:{"color":"red","outlined":"","label":""}},[_vm._v(" No ")])
}
var staticRenderFns = []

export { render, staticRenderFns }